@if (visible) {
    <form #stepForm="ngForm" class="form-page">
        <label>
            {{ 'form.language' | translate }}
            <input type="text" name="language" required hidden [(ngModel)]="form.language" />
            <div class="pills">
                @for (language of languages; track language) {
                    <button
                        (click)="setLanguage(language)"
                        class="pill-option"
                        [class.active]="language === form.language"
                    >
                        {{ 'languages.' + language | translate }}
                    </button>
                }
            </div>
        </label>
        <label>
            {{ 'form.emailAddress' | translate }}
            <input
                #emailAddress="ngModel"
                type="email"
                name="emailAddress"
                email
                (keyup)="updateNextButton()"
                [placeholder]="'form.emailAddress' | translate"
                [(ngModel)]="form.emailAddress"
            />
        </label>
        @if (stepForm.invalid) {
            <div class="form-error">
                @if (emailAddress.errors?.email) {
                    <div>
                        {{ 'errors.invalidEmail' | translate }}
                    </div>
                }
            </div>
        }
    </form>
}
@if (!visible) {
    <ogs-spinner @fade></ogs-spinner>
}
